import { TGetConstructionProgressResponse_1 as IGetConstructionProgressResponseSchema } from '../repositories/construction-progress/v1/get-construction-progress';
import { IGetConstructionProgressResponse } from '../types/constructionProgress';
import { prepareConstructionProgress } from './constructionProgress/prepareConstructionProgress';

export function transformConstructionProgressResponse({
  isLast,
  newbuildingName,
  totalImagesCount,
  constructionProgress,
}: IGetConstructionProgressResponseSchema): IGetConstructionProgressResponse {
  return {
    isLast,
    newbuildingName,
    totalImagesCount,
    constructionProgress: constructionProgress.map(item => prepareConstructionProgress(item, newbuildingName)),
  };
}
